import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import HeaderDialog from 'components/foundation/dialogs/HeaderDialog/HeaderDialog';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IEquipmentCatMakeModelDeleteProhibitedDialogProps {
  className?: ClassName;
  type: 'category' | 'make' | 'model';
  isOpen: boolean;
  onClose: () => void;
}

const EquipmentCatMakeModelDeleteProhibitedDialog = (props: IEquipmentCatMakeModelDeleteProhibitedDialogProps) => {
  const { className, isOpen, type, onClose } = props;

  const classes = classNames('delete-prohibited-dialog', className);

  return (
    <HeaderDialog title={t('Delete Prohibited')} isOpen={isOpen} onClose={onClose} divider={false} className={classes}>
      <div className="mx-8 my-5">
        <div>
          {t(
            `You currently have items assigned to this ${type}. You will need to reassign or delete those items before the ${type} can be deleted.`
          )}
        </div>
        <Button type={'secondary'} className={'mt-5'} onClick={onClose}>
          {t('Close')}
        </Button>
      </div>
    </HeaderDialog>
  );
};

export default EquipmentCatMakeModelDeleteProhibitedDialog;
